import { MODULE as PARENT } from '../constants'

export const KEY = 'contracts'
export const MODULE = [...[PARENT], KEY]

export const CLEAR_CONTRACTS = `${KEY}-clear`
export const SET_CURRENT_CONTRACT = `${KEY}-set-current`
export const FETCH_CONTRACTS = `${KEY}-fetch`
export const POPULATE_CONTRACTS = `${KEY}-populate`
